<template>

  <div class="container" v-if="response && response.professor">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'professorat', params: {page: $route.params.listPage || 1, sort: $route.params.listSort || 'professor_nom_sort asc'}}">{{$t('Professorat')}}</router-link-locale></li>
        <li v-if="response.professor" class="breadcrumb-item active" aria-current="page">{{ response.professor.professor_nom }}</li>
      </ol>
    </nav>


    <h1 class="d-flex justify-content-between">
      <span>{{ response.professor.professor_nom.split(',')[1] + " " + response.professor.professor_nom.split(',')[0] }}</span>
      <span class="text-secondary h5" style="position: relative; top: 15px;">Activitats<span class="badge rounded-pill badge-upc ms-2">{{response.professor.professor_num_activitats }}</span> </span>
    </h1>

    <div class="row">


      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="response.professor">

          <div class="card-body">

            <div class="m-t-20 row">
              <div class="col-md-2 col-xs-12 text-center mb-2">
                <img v-if="response.professor.professor_foto" v-bind:src="response.professor.professor_foto" alt="user" class="img-responsive img-thumbnail rounded-0">
                <div v-else ><i style="color: #5fa728;" class="fa-regular fa-circle-user fa-8x mb-2"></i></div>
                <!--img v-else src="../assets/images/perfil.png" alt="user" class="img-responsive rounded float-left shadow"-->
              </div>
              <div class="col-md-10">

                <div class="row mb-1" v-if="response.professor.professor_centre_docent">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Centre Docent')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="centre in response.professor.professor_centre_docent" v-bind:key="centre">
                      <div class="mb-1">
                        <!--router-link :to="{name: 'organitzacio', params: {tipus:'centre', id: centre}}"-->
                        <router-link :to="{name: 'organitzacio', params: {id: centre}}">
                          {{$t(centre)}}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_centre_docent_ads">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Centre Docent')}} (ads)</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="centre in response.professor.professor_centre_docent_ads" v-bind:key="centre">
                      <div class="mb-1">
                        <!--router-link :to="{name: 'organitzacio', params: {tipus:'centre', id: centre}}"-->
                        <router-link :to="{name: 'organitzacio', params: {id: centre}}">
                          {{$t(centre)}}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_departament">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Departament')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="departament in response.professor.professor_departament" v-bind:key="departament">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: departament}}">{{$t(departament)}}</router-link></div>
                    </div>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_departament_ads">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Departament')}} (ads)</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="departament in response.professor.professor_departament_ads" v-bind:key="departament">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: departament}}">{{$t(departament)}}</router-link></div>
                    </div>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_institut">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Institut')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="institut in response.professor.professor_institut" v-bind:key="institut">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: institut}}">{{$t(institut)}}</router-link></div>
                    </div>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_institut_ads">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Institut')}} (ads)</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="institut in response.professor.professor_institut_ads" v-bind:key="institut">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: institut}}">{{$t(institut)}}</router-link></div>
                    </div>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_grups">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('activitat_grups')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="grup in response.professor.professor_grups" v-bind:key="grup">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: grup}}">{{$t(grup)}}</router-link></div>
                    </div>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_campus">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Campus')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div class="mb-1">{{response.professor.professor_campus}}</div>
                  </div>
                </div>

                <!--div v-if="response.professor.professor_email" class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Categoria professional')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      {{response.professor.professor_categoria_profesional.toLocaleString()}}
                    </p>
                  </div>
                </div-->

                <div class="row mb-1" v-if="response.professor.professor_orcidId">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">Orcid</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      <a :href="'https://orcid.org/' + response.professor.professor_orcidId" target="_blank" rel="noreferrer noopener">{{response.professor.professor_orcidId}} <i class="fa-solid fa-external-link mini-icon"></i></a>
                    </p>
                  </div>
                </div>

                <hr v-if="response.professor.professor_centre_docent || response.professor.professor_departament || response.professor.professor_institut">

                <div v-if="response.professor.professor_email" class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Correu electrònic')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      {{response.professor.professor_email.toLowerCase().split('@')[0]}}<i class="fas fa-at fa-1x"></i>{{response.professor.professor_email.toLowerCase().split('@')[1]}}
                    </p>
                  </div>
                </div>

                <div class="row mb-1">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Dades de contacte')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      <a :href="'https://directori.upc.edu/directori/dadesPersona.jsp?id=' + response.professor.professor_gaussId" target="_blank" rel="noreferrer noopener">{{$t('Directori de la UPC')}} <i class="fa-solid fa-external-link mini-icon"></i></a>
                    </p>
                  </div>
                </div>

                <div v-if="responseDocencia.docencia && (filteredDocenciaActual.length > 0 || responseDocencia.docencia.length > 0)">

                  <hr>
                  <div class="row mb-1" v-if="filteredDocenciaActual.length > 0">
                    <div class="col-md-3 col-xs-12">
                      <p class="mb-1 fw-bold">
                        {{$t('Docencia')}}
                        <span>
                          {{cursCurrentInfo.curs}}
                        </span>
                      </p>
                    </div>
                    <div class="col-md-9 col-xs-12" v-if="filteredDocenciaActual.length > 0">
                      <div class="mb-2 d-flex justify-content-between align-items-start">
                        <span v-if="filteredDocenciaActual.length > 0">
                          {{$t('Impartida')}} <span  class="badge rounded-pill ms-0 badge-upc">{{filteredDocenciaActual.length}}</span> -
                          {{$t('Responsable-coordinada')}} <span  class="badge rounded-pill ms-0 badge-upc">{{numCoordinadasActual}}</span>
                        </span>
                        <span v-else>
                          Sense docencia assignada
                        </span>
                        <a @click='hideShowDocenciaActual = !hideShowDocenciaActual' style="cursor:pointer;" class="text-secondary mr-1">
                          <i v-if="!hideShowDocenciaActual" class="fa-regular fa-plus fa-xl me-2"></i>
                          <i v-if="hideShowDocenciaActual" class="fa fa-minus me-2"></i>
                        </a>
                      </div>

                      <div class="row" v-if="hideShowDocenciaActual">

                        <ul class="list-group w-100">

                          <li v-for="(docencia, index) in filteredDocenciaActual" :key="index" class="m-0 list-group-item rounded-0 d-flex justify-content-between align-items-center">

                            <!-- Primer span (sin truncar, con tamaño fijo) -->
                            <span class="small text-secondary flex-shrink-0 me-3">
                              {{ docencia.data }}/{{ parseInt(docencia.data)+1 }}
                              <span class="badge rounded-pill ms-1" :class="docencia.activitat_quadrimestre === '1' ? 'bg-primary' : 'bg-warning'">
                                Q{{ docencia.activitat_quadrimestre }}
                              </span>
                              <span v-if="docencia.activitat_responsable && docencia.activitat_responsable.some(r => r.split('##')[1] === response.professor.id)" class="badge rounded-pill ms-1 bg-danger">R</span>
                            </span>

                            <!-- Segundo span (con truncado y flex-grow) -->
                            <span class="small text-success text-truncate text-end flex-grow-1" v-if="docencia.activitat_assignatures">
                              <router-link :to="{name: 'assignatura', params: {id: docencia.activitat_assignatures[0]}}">
                                {{$t(docencia.activitat_assignatures[0])}}
                              </router-link>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-1" v-if="responseDocencia.docencia.length > 0">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Docencia completa')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <div class="mb-2 d-flex justify-content-between align-items-start">
                        <span v-if="responseDocencia.docencia.length > 0">
                          {{$t('Impartida')}} <span  class="badge rounded-pill ms-0 badge-upc">{{responseDocencia.docencia.filter(docencia => docencia.activitat_subtipus_docencia === 'assignaturesImpartidas').length}}</span> -
                          {{$t('Responsable-coordinada')}} <span  class="badge rounded-pill ms-0 badge-upc">{{numCoordinadas}}</span>
                        </span>
                        <span v-else>
                          Sense docencia assignada
                        </span>
                        <a @click='hideShowDocenciaTotal = !hideShowDocenciaTotal' style="cursor:pointer;" class="text-secondary mr-1">
                          <i v-if="!hideShowDocenciaTotal" class="fa-regular fa-plus fa-xl me-2"></i>
                          <i v-if="hideShowDocenciaTotal" class="fa fa-minus me-2"></i>
                        </a>

                      </div>
                      <div class="row" v-if="hideShowDocenciaTotal">

                        <ul class="list-group w-100">

                          <li v-for="(docencia, index) in responseDocencia.docencia.filter(docencia => docencia.activitat_subtipus_docencia === 'assignaturesImpartidas')" :key="index" class="m-0 list-group-item rounded-0 d-flex justify-content-between align-items-center">

                            <!-- Primer span (sin truncar, con tamaño fijo) -->
                            <span class="small text-secondary flex-shrink-0 me-3">
                              {{ docencia.data }}/{{ parseInt(docencia.data)+1 }}
                              <span class="badge rounded-pill ms-1" :class="docencia.activitat_quadrimestre === '1' ? 'bg-primary' : 'bg-warning'">
                                Q{{ docencia.activitat_quadrimestre }}
                              </span>
                              <!--i v-if="docencia.activitat_responsable && docencia.activitat_responsable.split('##')[1] == response.professor.id" class="fa-solid fa-registered text-danger bold fa-xl ms-1"></i-->
                              <span v-if="docencia.activitat_responsable && docencia.activitat_responsable.some(r => r.split('##')[1] === response.professor.id)" class="badge rounded-pill ms-1 bg-danger">R</span>
                            </span>

                            <!-- Segundo span (con truncado y flex-grow) -->
                            <span class="small text-success text-truncate text-end flex-grow-1">
                              <router-link v-if="docencia.activitat_assignatures" :to="{name: 'assignatura', params: {id: docencia.activitat_assignatures[0]}}">
                                {{$t(docencia.activitat_assignatures[0])}}
                              </router-link>
                              <span v-else class="text-danger">ERROR EN ELS IDs{{ docencia.id }}</span>
                            </span>

                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>


                </div>


                <hr>

                <div class="row mb-1" v-if="response.professor.professor_assignatures">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Assignatures on ha impartit docencia')}}</p></div>
                  <div class="col-md-9 col-xs-12">

                    <div v-if="!hideShowAllAssignatures" >
                      <!--div v-for="assignatura in response.professor.professor_assignatures.slice(0, 5)" v-bind:key="assignatura">
                        <div class="mb-1"><router-link :to="{name: 'assignatura', params: {id: assignatura}}">{{$t(assignatura)}}</router-link></div>
                      </div-->
                      <div v-for="assignatura in sortedAssignatures.slice(0, 5)" v-bind:key="assignatura">
                        <div class="mb-1"><router-link :to="{name: 'assignatura', params: {id: assignatura.id}}">{{assignatura.name}}</router-link></div>
                      </div>
                    </div>
                    <div v-else>
                      <!--div v-for="assignatura in response.professor.professor_assignatures" v-bind:key="assignatura">
                        <div class="mb-1"><router-link :to="{name: 'assignatura', params: {id: assignatura}}">{{$t(assignatura)}}</router-link></div>
                      </div-->
                      <div v-for="assignatura in sortedAssignatures" v-bind:key="assignatura">
                        <div class="mb-1"><router-link :to="{name: 'assignatura', params: {id: assignatura.id}}">{{assignatura.name}}</router-link></div>
                      </div>
                    </div>

                    <a v-if="response.professor.professor_assignatures.length > 5" @click='hideShowAllAssignatures = !hideShowAllAssignatures' style="cursor:pointer;" class="text-secondary mr-1">
                      <i v-if="!hideShowAllAssignatures" class="fa-solid fa-plus me-2 fa-bold text-blue"></i>
                      <i v-if="hideShowAllAssignatures" class="fa-solid fa-minus me-2 fa-bold text-blue"></i>
                    </a>
                    <hr>
                  </div>
                </div>

                <div class="row mb-1" v-if="response.professor.professor_centres_titulacions">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Centres on ha impartit docencia')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-if="!hideShowAllCentres" >
                      <!--div v-for="titulacio in response.professor.professor_titulacions.slice(0, 5)" v-bind:key="titulacio">
                        <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link></div>
                      </div-->
                      <div v-for="centre in sortedCentres.slice(0, 5)" v-bind:key="centre">
                        <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: centre.id}}">{{$t(centre.id)}}</router-link></div>
                      </div>
                    </div>
                    <div v-else>
                      <!--div v-for="titulacio in response.professor.professor_titulacions" v-bind:key="titulacio">
                        <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link></div>
                      </div-->
                      <div v-for="centre in sortedCentres" v-bind:key="centre">
                        <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: centre.id}}">{{$t(centre.id)}}</router-link></div>
                      </div>
                    </div>

                    <a v-if="response.professor.professor_centres_titulacions.length > 5" @click='hideShowAllCentres = !hideShowAllCentres' style="cursor:pointer;" class="text-secondary mr-1">
                      <i v-if="!hideShowAllCentres" class="fa-solid fa-plus me-2 fa-bold text-blue"></i>
                      <i v-if="hideShowAllCentres" class="fa-solid fa-minus me-2 fa-bold text-blue"></i>
                    </a>
                    <hr>
                  </div>

                </div>



                <div class="row mb-1" v-if="response.professor.professor_titulacions">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Titulacions vinculades amb les assignatures')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-if="!hideShowAllTitulacions" >
                      <!--div v-for="titulacio in response.professor.professor_titulacions.slice(0, 5)" v-bind:key="titulacio">
                        <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link></div>
                      </div-->
                      <div v-for="titulacio in sortedTitulacions.slice(0, 5)" v-bind:key="titulacio">
                        <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio.id}}">{{titulacio.name}}</router-link></div>
                      </div>
                    </div>
                    <div v-else>
                      <!--div v-for="titulacio in response.professor.professor_titulacions" v-bind:key="titulacio">
                        <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link></div>
                      </div-->
                      <div v-for="titulacio in sortedTitulacions" v-bind:key="titulacio">
                        <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio.id}}">{{titulacio.name}}</router-link></div>
                      </div>
                    </div>

                    <a v-if="response.professor.professor_titulacions.length > 5" @click='hideShowAllTitulacions = !hideShowAllTitulacions' style="cursor:pointer;" class="text-secondary mr-1">
                      <i v-if="!hideShowAllTitulacions" class="fa-solid fa-plus me-2 fa-bold text-blue"></i>
                      <i v-if="hideShowAllTitulacions" class="fa-solid fa-minus me-2 fa-bold text-blue"></i>
                    </a>

                    <div class="mt-3 p-2 small" style="font-style: italic; border-left: 3px solid #ffc107; background-color: #fff3cd; color: #856404;">
                      <i class="fas fa-info-circle me-1"></i>
                      {{$t('nota_titulacions_relacionades_assignatures')}}
                    </div>
                  </div>
                </div>


              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <img src="../assets/images/mini-upc.svg" width="20" alt="directori UPC" class="me-1 d-none d-lg-block img-fluid">
                  <a class="me-4 d-none d-lg-block" :href="'https://directori.upc.edu/directori/dadesPersona.jsp?id=' + response.professor.professor_gaussId" target="_blank" rel="noreferrer noopener">{{$t('Directori de la UPC')}} <i class="fa-solid fa-external-link mini-icon"></i></a>

                  <img src="../assets/images/mini-upc.svg" width="20" alt="Cataleg biblioteques Discovery UPC" class="me-1 d-none d-lg-block">
                  <a class="me-4 d-none d-lg-block" :href="'https://discovery.upc.edu/discovery/search?tab=Alma_records&search_scope=Alma_records&vid=34CSUC_UPC:VU1&offset=0&query=creator,exact,' + response.professor.professor_nom" target="_blank" rel="noreferrer noopener">{{$t('Cataleg biblioteques')}} <i class="fa-solid fa-external-link mini-icon"></i></a>

                  <div v-if="response.professor.professor_futur">
                    <a v-if="response.professor.professor_dracId" class="me-4" :href="'https://futur.upc.edu/' + response.professor.professor_dracId[0]" target="_blank" rel="noreferrer noopener"><img src="../assets/images/futur-bola.png" alt="user" class="me-1"></a>
                    <a v-else class="me-4" :href="'https://futur.upc.edu/' + response.professor.id" target="_blank" rel="noreferrer noopener"><img src="../assets/images/futur-bola.png" alt="user" class="me-1"> </a>
                  </div>

                  <img src="../assets/images/mini-rss.svg" width="20" alt="user" class="me-1">
                  <a class="me-4" :href="'https://apren.upc.edu/api/RSS/' + response.professor.id" target="_blank" rel="noreferrer noopener">{{$t('RSS')}}</a>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>


    <div class="row mt-4">
      <MaterialsCommon :init-query="initQuery" router-name="professor" :key="initQuery"></MaterialsCommon>
    </div>

  </div>

  <div v-else class="container rounded-0" role="alert">

    {{ $t("No results") }}

  </div>

</template>

<script>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import {routeLocationKey, useRoute} from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import store from "@/store";
import {setMetadataProfessorName} from "@/composables/metadataFunctions";
import ProfessorService from "@/services/ProfessorService";
import MaterialsCommon from "@/components/MaterialsCommon.vue";
import {cursActual, obtenerCursActual} from "@/utils/utils";
import {all} from "axios";
import {useI18n} from "vue-i18n";

  export default {
    name: "ProfessorsView",
    computed: {
      routeLocationKey() {
        return routeLocationKey
      }
    },
    methods: {all, obtenerCursActual, cursActual},
    components: {
      MaterialsCommon,
      RouterLinkLocale
    },

    setup() {
      const response = ref([]);
      const responseMaterials = ref([]);
      const responseDocencia = ref([]);
      const cursCurrentInfo = ref(null);
      const route = useRoute();
      const hideShowDocenciaActual = ref(false)
      const hideShowDocenciaTotal = ref(false)
      const hideShowAllAssignatures = ref(false)
      const hideShowAllTitulacions = ref(false)
      const hideShowAllCentres = ref(false)


      const { t } = useI18n();

      // Ordenar las asignaturas según la traducción
      const sortedAssignatures = computed(() => {
        if (!response.value.professor) return [];
        return response.value.professor.professor_assignatures
            .map(assignatura => ({ id: assignatura, name: t(assignatura) }))
            .sort((a, b) => a.name.localeCompare(b.name))
      });

      // Ordenar las titulaciones según la traducción
      const sortedTitulacions = computed(() => {
        if (!response.value.professor) return [];
        return response.value.professor.professor_titulacions
            .map(titulacio => ({ id: titulacio, name: t(titulacio) }))
            .sort((a, b) => a.name.localeCompare(b.name))
      });

      // Ordenar los centros según la traducción
      const sortedCentres = computed(() => {
        if (!response.value.professor) return [];
        return response.value.professor.professor_centres_titulacions
            .map(centre => ({ id: centre, name: centre }))
            .sort((a, b) => a.name.localeCompare(b.name))
      });


      // Construir la query en base al id en los params
      const initQuery = computed(() => {
        const id = route.params.id;
        return `(activitat_professors:${id} OR activitat_altresAutories:${id})`;
      });

      /*watch(
          () => route.fullPath,
          () => {
            const id = route.params.id;
            if (id) {
              initQuery.value = `(activitat_professors:${id} OR activitat_altresAutories:${id})`;
            }
          },
          { immediate: true }
      );*/

      watch(
          () => route.params.id,
          async (newId, oldId) => {
            if (newId !== oldId) {
              response.value = await ProfessorService.getProfessor(newId);
              responseDocencia.value = await ProfessorService.getDocenciaProfessor(newId);
              setMetadataProfessorName(response.value.professor.professor_nom);
              cursCurrentInfo.value = obtenerCursActual();
              initQuery.value = `(activitat_professors:${newId} OR activitat_altresAutories:${newId})`;

              await nextTick();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          },
          { immediate: true }
      );


      /*watchEffect(async() => {
        const id = route.params.id;
        response.value = await ProfessorService.getProfessor(id)
        responseDocencia.value = await ProfessorService.getDocenciaProfessor(id)
        setMetadataProfessorName(response.value.professor.professor_nom)
        cursCurrentInfo.value = obtenerCursActual()
        initQuery.value = `(activitat_professors:${id} OR activitat_altresAutories:${id})`;
        await nextTick();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });*/


      const filteredDocenciaActual = computed(() => {
        return responseDocencia.value.docencia.filter(docencia =>
            docencia.activitat_subtipus_docencia === "assignaturesImpartidas" &&
            docencia.data == cursCurrentInfo.value.any
        );
      });

      const numCoordinadasActual = computed(() => {
        return filteredDocenciaActual.value.filter(docencia =>
            Array.isArray(docencia.activitat_responsable) &&
            docencia.activitat_responsable.some(responsable =>
                responsable.split('##')[1] === route.params.id
            )
        ).length;
      });

      const numCoordinadas = computed(() => {
        return responseDocencia.value.docencia.filter(docencia =>
            Array.isArray(docencia.activitat_responsable) &&
            docencia.activitat_responsable.some(responsable =>
                responsable.split('##')[1] === route.params.id
            )
        ).length;
      });



      /*const filteredDocenciaWithoutActual = computed(() => {
        return responseDocencia.value.docencia.filter(docencia =>
            docencia.data != cursCurrentInfo.value.any ||
            docencia.activitat_quadrimestre != cursCurrentInfo.value.q
        );
      });*/


      onMounted(async () => {
        await store.dispatch('updateSearchSelected', "Professorat");
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-blue.webp') });
        const id = route.params.id;
        response.value = await ProfessorService.getProfessor(id)
        responseDocencia.value = await ProfessorService.getDocenciaProfessor(id)
        setMetadataProfessorName(response.value.professor.professor_nom)
        cursCurrentInfo.value = obtenerCursActual()

      });



      return {
        response,
        responseDocencia,
        responseMaterials,
        cursCurrentInfo,
        filteredDocenciaActual,
        numCoordinadasActual,
        numCoordinadas,
        hideShowDocenciaActual,
        hideShowDocenciaTotal,
        hideShowAllAssignatures,
        hideShowAllTitulacions,
        hideShowAllCentres,
        initQuery,
        sortedTitulacions,
        sortedAssignatures,
        sortedCentres
      }

    }

  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}
</style>
